// importing the authentication css for global stylings
import "../styles/GlobalAuth.css";

// importing the login screen css file for the styling
// import "./styles/RightComponent.css";

// importing the components for getting input fields and buttons
import LeftComponent from "./components/LeftComponent";

// importing the auth container for wrapping out contexts
import AuthContainer from "../../global/AuthContainer";
import { useMessageContext } from "../../../hooks/UseMessageContext";

import { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPasswordService } from "../../../services/auth/forgotPasswordService";

export default function ForgotPassword() {
  const { dispatch2 } = useMessageContext();
  const { messageArray } = useMessageContext();
  const [email, setEmail] = useState("");
  const [emailSent, setEmailSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [emailError, setEmailError] = useState("");

  const submitForgotPassword = async () => {
    if (!email) {
      dispatch2({
        type: "MESSAGEARRAY",
        payload: [...messageArray, "Please enter your email address"],
      });
      return;
    }
    setSubmitting(true);
    const response = await forgotPasswordService(email);
    setSubmitting(false);
    // The backend now distinguishes a registered vs. unregistered email again (client
    // requirement) - only transition to the "Check Your Email" state on an actual success;
    // otherwise stay on this screen and surface the message the backend returned.
    if (response && response.status === "successfull") {
      setEmailError("");
      setEmailSent(true);
    } else {
      setEmailError(
        response?.message ||
          "The email address you entered is not registered with us. Please try the email address used during registration, which may be your own, your parent's, or your guardian's email address."
      );
    }
  };

  const handleKeyDown = async (event) => {
    if (event.keyCode === 13) {
      submitForgotPassword();
    }
  };

  return (
    <AuthContainer>
      <LeftComponent />
      {/* below division wraps all the login field */}
      <div className="RightComponentLoginFields">
        {/* below division wraps the headings */}
        <div className="RightComponentHeading">
          <h1 className={emailSent ? "" : "ForgotPasswordHeading"}>
            {emailSent ? "Check Your Email" : "Forgot Your Password?"}
          </h1>
        </div>
        {/* below division wraps the two input  and button */}
        <div className="RightComponentInputFields">
          {emailSent ? (
            <p className="AuthContainerBold ForgotSuccessMessage">
              If an account exists for <span className="ForgotSuccessEmail">{email}</span>, a password reset link has been sent.
              Please check your Inbox, Spam, or Junk folder.
            </p>
          ) : (
            <>
              <input
                autoComplete="email"
                placeholder="Email"
                className="InputFieldClass"
                type="email"
                value={email}
                onChange={(event) => {
                  setEmail(event.target.value);
                  if (emailError) {
                    setEmailError("");
                  }
                }}
                onKeyDown={handleKeyDown}
              />
              {emailError && <p className="AuthErrorText">{emailError}</p>}
            </>
          )}
          {!emailSent && (
            <button disabled={submitting} onClick={submitForgotPassword}>
              {submitting ? "SENDING..." : "RESET PASSWORD"}
            </button>
          )}
          <div
            className={
              emailSent
                ? "RightComponentBacktoFont RightComponentBacktoFontSpaced"
                : "RightComponentBacktoFont"
            }
          >
            <p className="AuthContainerBold">Or</p>
            <Link to={"/"}>
              <p className="AuthContainerBold">Back to Sign In</p>
            </Link>
          </div>
        </div>
      </div>
    </AuthContainer>
  );
}
